















































import { AisRefinementList, AisStats } from 'vue-instantsearch'
export default

	components: {
		AisRefinementList
		AisStats
	}

	props:
		refinementLists: Array
		refinementItemTitles: Object
		titleText: String
		openIconClass: String
		closeIconClass: String

	methods:

		# Hide and show the filters using vanilla JS because Algolia loses the
		# state whenever Vue re-renders the component, like when I use transitions
		# or Vue classes.
		onToggle: (open) -> if open then @openAccordion() else @closeAccordion()

		# Open the mobile panel
		openAccordion: ->
			return unless contentEl = @getAccordionContentEl()
			clearTimeout @toggleTimeout
			@$refs.accordion.style.height = "#{contentEl.clientHeight + 1}px"
			@toggleTimeout = setTimeout =>
				@$refs.accordion.style.height = 'auto'
			, 300

		# Close the mobile panel
		closeAccordion: ->
			return unless contentEl = @getAccordionContentEl()
			@$refs.accordion.style.height = "#{contentEl.clientHeight + 1}px"
			setTimeout => @$refs.accordion.style.height = 0

		# Get the accordion content el
		getAccordionContentEl: -> @$refs.accordion.children[0]

		# Convert slugs to titles using refinementItemTitles prop
		makeRefinementListItemTitle: (items) -> items.map (item) => {
			...item
			label: @refinementItemTitles[item.value] || item.label
		}

